import React from "react";
import { DateTimeProps } from "./types";
import styles from "./DateTimeDisplay.module.scss";

const DateTimeDisplay: React.FC<DateTimeProps> = ({
  value,
  type,
  isDanger,
}) => {
  const divClassName = isDanger ? styles.countdown__danger : styles.countdown;

  return (
    <div className={divClassName}>
      <p className={styles.countdown__value}>{value}</p>
      <span className={styles.countdown__type}>{type}</span>
    </div>
  );
};

export default DateTimeDisplay;
